<template>

    <v-col
        cols="12"
        :md="((displayType == 'table') && !($vuetify.breakpoint.xs || $vuetify.breakpoint.sm)) ? 12 : 6"
    >

		<template v-if="(displayType == 'table') && !($vuetify.breakpoint.xs || $vuetify.breakpoint.sm)">

			<v-card
				class="mx-auto pa-3"
				outlined
			>

				<div class="d-flex align-center body-2">

					<v-avatar
						size="120"
						tile
						class="mr-3"
					>
						<v-img :src="imgSrc"></v-img>
					</v-avatar>

					<div class="d-flex justify-end flex-grow-1">

						<div class="flex-grow-1 mr-8">
							<div class="font-weight-bold mb-1">{{atlas["title"]}}</div>
							<div>{{atlas["shortDescription"] | truncate(200, '...')}}</div>
						</div>

						<div class="d-flex align-center caption text-no-wrap">

							<div class="mr-6">
								<div class="font-weight-bold">Tipas</div>
								<div>{{getAtlasType(atlas["atlasType"])}}</div>
							</div>

							<div class="mr-6">
								<div class="font-weight-bold">Redagavimo data</div>
								<div>{{atlas["updateDate"]}}</div>
							</div>

							<div class="mr-3">
								<div class="font-weight-bold">Autorius</div>
								<div>{{atlas["owner"]}}</div>
							</div>

						</div>

					</div>

				</div>

				<v-btn class="mt-2" color="blue" text v-on:click="preview">
					Peržiūrėti
				</v-btn>

			</v-card>

		</template>

		<template v-else>
		
			<v-card
				flat
				height="550px"
				hover
			>
				<!--  
					TODO FIX: src reikšmė turi būti dinamis atlaso img arba default img
				-->
				<v-img
					dark
					class="white--text align-end atlas-gallery-image"
					height="300px"
					:src="imgSrc"
				>
					<v-card-title>{{atlas["title"]}}</v-card-title>
				</v-img>

				<v-card-subtitle class="pb-0">{{atlas["createDate"]}}</v-card-subtitle>

				<v-card-text class="text--primary">
					<div>{{atlas["shortDescription"] | truncate(200, '...') }}</div>

					<br>

					<div><small>Tipas: {{getAtlasType(atlas["atlasType"])}}</small></div>
					<div><small>Sukūrė: {{atlas["owner"]}}</small></div>
				</v-card-text>

				<v-card-actions>
					<v-btn color="blue" text v-on:click="preview">
						Peržiūrėti
					</v-btn>
				</v-card-actions>
				
			</v-card>

		</template>
    
    </v-col>

</template>

<script>
	import AtlasHelper from "../helpers/AtlasHelper";

	export default {
		props: {
            atlas: Object,
			getList: Function,
            editable: Boolean,
			displayType: String
		},
		data: function(){
			var imgSrc;
			if (this.atlas.images && this.atlas.images.length) {
				imgSrc = AtlasHelper.getImageUrl(this.atlas.atlasID, this.atlas.images[0].atlasImageID);
			}
			var data = {
				imgSrc: imgSrc
			};
			return data;
		},
		methods: {
			preview: function(){
				window.open(this.$router.history.base + "/atlas/" + this.atlas.atlasID, "_blank");
			},
			getAtlasType: function(atlasType){
				var atlasTypes = AtlasHelper.getAtlasTypes();
				if (atlasTypes) {
					atlasTypes.some(function(item){
						if (item.key == atlasType) {
							atlasType = item.name;
							return true;
						}
					});
				}
				return atlasType;
			}
		}
    };
</script>

<style scoped>
	.link {
		color: inherit;
		text-decoration: none;
	};
</style>